import { Spacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Container = styled(Spacer).attrs({
  orientation: 'vertical',
  space: 0,
})`
  padding: 8px 2px;
`;
